
document.addEventListener('DOMContentLoaded', function () {
    if (window.WOW) new WOW().init();
  });
// Faq Tabing JS Start

$(document).on("click",".faq-tab-btn",function(){
  var id_tab=$(this).attr("data-val");
  $(".faq-tab-btn").removeClass("active");
  $(this).addClass("active");
  
  $(".tab_body").removeClass("active");
  $(".tab_body."+id_tab).addClass("active");
});


 $(document).ready(function () {
 jQuery(".common-faq-area .accordion-heading").click(function(e){
      if(!$(this).closest(".accordion-box").hasClass("open"))
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
      $(this).closest(".accordion-box").find(".accordion_body").slideToggle();
      $(this).closest(".accordion-box").toggleClass("open");
    }
    else
    {
      $(".accordion-box .accordion_body").slideUp();
      $(".accordion-box").removeClass("open");
    }
  });
});


$(document).ready(function () {
  // Open all by default
  $(".reference-faq-area .accordion-box").addClass("open");
  $(".reference-faq-area .accordion_body").show();

  // Toggle open/close on click
  $(".reference-faq-area .accordion-heading").click(function () {
    var parentBox = $(this).closest(".accordion-box");

    if (parentBox.hasClass("open")) {
      parentBox.removeClass("open");
      parentBox.find(".accordion_body").slideUp();
    } else {
      parentBox.addClass("open");
      parentBox.find(".accordion_body").slideDown();
    }
  });
});


  // Faq Tabing JS End

  // Faq Serch JS Start

$(document).ready(function () {

  function filterFAQ() {
    var value = $("#faqSearch").val().toLowerCase().trim();

    if (value === "") {
      // If input is empty, show all accordion boxes
      $(".accordion-box").show();
    } else {
      // Filter and show only matching boxes
      $(".accordion-box").filter(function () {
        $(this).toggle($(this).text().toLowerCase().indexOf(value) > -1);
      });
    }
  }

  // Real-time search as user types
  $("#faqSearch").on("input", function () {
    filterFAQ();
  });

});

// Faq Serch JS End

  // Faq Page JS End


    // Home Page JS Start

// Video Review Slider JS Start
$(document).ready(function () {
  const $carousel = $(".testimonial-carousel");

  $carousel.owlCarousel({
    items: 3,
    margin: 24,
    autoplay: false,   // ✅ autoplay disabled
    autoplayTimeout: 4000,
    slideSpeed: 300,
    loop: true,
    nav: true,
    dots: true,
    dotsEach: 1,     
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
      "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
    ],
    responsive: {
      0: { items: 2 },
      480: { items: 2 },
      700: { items: 2 },
      1000: { items: 3 },
      1100: { items: 3 }
    }
  });

  const allVideos = document.querySelectorAll('.testimonial-video');

  allVideos.forEach(function (video) {
    const wrapper = video.closest('.video-wrapper');
    const playIcon = wrapper.querySelector('.custom-play-btn');

    function playThisVideo() {
      // Pause other videos
      allVideos.forEach(function (v) {
        if (v !== video) {
          v.pause();
          const otherPlayIcon = v.closest('.video-wrapper').querySelector('.custom-play-btn');
          otherPlayIcon.style.opacity = 1;
          otherPlayIcon.style.pointerEvents = 'auto';
        }
      });

      // Play this video
      video.play();
      playIcon.style.opacity = 0;
      playIcon.style.pointerEvents = 'none';
    }

    function pauseThisVideo() {
      video.pause();
      playIcon.style.opacity = 1;
      playIcon.style.pointerEvents = 'auto';
    }

    // Click on play icon → play video
    playIcon.addEventListener('click', function () {
      playThisVideo();
    });

    // Click anywhere on video → toggle play/pause
    video.addEventListener('click', function () {
      if (video.paused) {
        playThisVideo();
      } else {
        pauseThisVideo();
      }
    });

    // When video ends → reset icon
    video.addEventListener('ended', function () {
      pauseThisVideo();
    });
  });
});

// Video Review Slider JS End



  // Video with text Section JS Start

document.addEventListener("DOMContentLoaded", function () {
  var videos = document.querySelectorAll(".rightVideo");

  videos.forEach(function (video) {
    var playPauseIcon = video.parentElement.querySelector(".playPauseIcon");

    if (!playPauseIcon) return;

    // Click on icon (same behavior as clicking video itself)
    playPauseIcon.addEventListener("click", function () {
      togglePlay(video, playPauseIcon);
    });

    // Click anywhere on video toggles play/pause
    video.addEventListener("click", function () {
      togglePlay(video, playPauseIcon);
    });

    // Keep icon synced with state
    video.addEventListener("pause", function () {
      playPauseIcon.style.display = "block";
    });

    video.addEventListener("play", function () {
      playPauseIcon.style.display = "none";
    });

    function togglePlay(video, icon) {
      if (video.paused) {
        video.play();
        icon.style.display = "none";
      } else {
        video.pause();
        icon.style.display = "block";
      }
    }
  });
});



  // Video With text Section JS End

  // Counter JS Start
  document.addEventListener("DOMContentLoaded", function () {
  const counters = document.querySelectorAll('.counter-number');

  const observer = new IntersectionObserver(function (entries, observer) {
    entries.forEach(function (entry) {
      if (entry.isIntersecting) {
        const $el = $(entry.target);
        const countTo = $el.attr('data-count');

        $({ countNum: 0 }).animate(
          { countNum: countTo },
          {
            duration: 2000,
            easing: 'swing',
            step: function () {
              $el.text(Math.floor(this.countNum).toLocaleString());
            },
            complete: function () {
              $el.text(Math.floor(this.countNum).toLocaleString() + '+');
            }
          }
        );

        observer.unobserve(entry.target); // prevent it from running again
      }
    });
  }, {
    threshold: 0.5 // trigger when 50% of element is visible
  });

  counters.forEach(counter => {
    observer.observe(counter);
  });
});


  // Counter JS End

  // Mobile Meet Hoodie Slider JS Start
  $('.meet-hoodie-carousel').owlCarousel({
	     margin:16,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
    dotsEach: 1,     
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:2
	        }
	    }
	}); 

  // Meet Hoodie Slider JS End

  // Home Page JS End


  // About Page JS Start

  // About Banner slider JS Start

  $(document).ready(function(){
    $('.about-model-carousel').slick({
  dots: false,
  arrows:false,
  infinite: true,
  autoplay: true,
  autoplaySpeed: 0,
  speed: 4000,
    pauseOnFocus: false,
  pauseOnHover: false,
  cssEase: 'linear',
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 3
      }
    }
    // You can unslick at a given breakpoint now by adding:
    // settings: "unslick"
    // instead of a settings object
  ]
});
  });

  // About Banner slider JS End

  // Why Choose Slider JS Start

  $('.why-choose-carousel').owlCarousel({
	     margin:0,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: false,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:1
	        },
	        1100:{
	            items:1
	        }
	    }
	}); 

  // Why Choose Slider JS End

  // From Concept Video Js Start

document.addEventListener("DOMContentLoaded", function () {
  const conceptSection = document.querySelector(".concept-video-section");
  if (!conceptSection) return;

  const videoCards = conceptSection.querySelectorAll(".concept-video-card");

  // Initialize Owl Carousel (mobile only, autoplay disabled)
  const $slider = $(".concept-mobile-slider").owlCarousel({
    margin: 16,
    loop: true,
    slideSpeed: 3000,
    paginationSpeed: 400,
    autoplay: false, // ✅ autoplay disabled
    nav: true,
    dots: true,
    navText: [
      "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
      "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
    ],
    responsive: {
      0: { items: 2 },
      480: { items: 2 },
      700: { items: 2 },
      1000: { items: 2 },
      1100: { items: 2 }
    }
  });

  videoCards.forEach((card) => {
    const video = card.querySelector("video");
    const playBtn = card.querySelector(".custom-play-btn");

    if (!video) return;

    // Handle play/pause toggle when clicking card or button
    function toggleVideoPlay(e) {
      e.stopPropagation();

      if (video.paused) {
        // Pause all other videos
        videoCards.forEach((otherCard) => {
          const otherVideo = otherCard.querySelector("video");
          const otherBtn = otherCard.querySelector(".custom-play-btn");
          if (otherVideo && otherVideo !== video) {
            otherVideo.pause();
            if (otherBtn) otherBtn.style.display = "block";
          }
        });

        // Play this video
        video.play();
        if (playBtn) playBtn.style.display = "none";
      } else {
        // Pause this video
        video.pause();
        if (playBtn) playBtn.style.display = "block";
      }
    }

    // Click anywhere on card
    card.addEventListener("click", toggleVideoPlay);

    // Also attach on play button
    if (playBtn) {
      playBtn.addEventListener("click", toggleVideoPlay);
    }

    // When video ends → just reset play button
    video.addEventListener("ended", function () {
      if (playBtn) playBtn.style.display = "block";
    });

    // When video pauses → just reset play button
    video.addEventListener("pause", function () {
      if (playBtn) playBtn.style.display = "block";
    });
  });
});


// From Concept Video JS End

  // From Concept Cideo JS end

  // Award slider JS start

$(document).ready(function(){
    
	$('.awards-carousel').owlCarousel({
	     margin:24,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
		 navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 
	 
});

// Awad JS ENd

// Feed Back Slider JS Start

$(document).ready(function(){
  $(".feedback-carousel").owlCarousel({
    margin:24,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:3
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:4
	        }
	    }
	}); 
});

// Feed Back JS End

// About Page Slider END

// Blog Page JS Start

document.addEventListener('DOMContentLoaded', function () {
  const btn = document.getElementById('load-more-btn');
  const wrapper = document.getElementById('blog-articles-wrapper');

  if (!btn) return;

  btn.addEventListener('click', function () {
    let nextPage = btn.dataset.nextPage;
    if (!nextPage) return;

    btn.innerHTML = 'Loading...';

    fetch(nextPage)
      .then(res => res.text())
      .then(html => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(html, 'text/html');

        // Get new articles
        const newArticles = doc.querySelectorAll('#blog-articles-wrapper > *');
        newArticles.forEach(article => wrapper.appendChild(article));

        // Update next page or remove button
        const newBtn = doc.querySelector('#load-more-btn');
        if (newBtn) {
          btn.dataset.nextPage = newBtn.dataset.nextPage;
          btn.innerHTML = `View More <img src="https://cdn.shopify.com/s/files/1/0714/5868/5233/files/Frame_19.svg?v=1754877470" style="min-width:24px;" class="img-responsive">`;
        } else {
          btn.remove();
        }
      })
      .catch(() => {
        btn.textContent = 'Error';
      });
  });
});




// Blog Page JS End

// Science Page JS Start

// Tabbing JS

document.addEventListener("DOMContentLoaded", function(){
  document.querySelectorAll(".how-help-info-tab-area").forEach(function(section){
    
    section.querySelectorAll(".tab-btn").forEach(function(btn){
      btn.addEventListener("click", function(){
        let val = this.getAttribute("data-val");

        section.querySelectorAll(".tab-btn").forEach(b => b.classList.remove("active"));
        this.classList.add("active");

        section.querySelectorAll(".tab-content").forEach(c => c.classList.remove("active"));
        section.querySelector("#" + val).classList.add("active");
      });
    });

  });
});

// Bubble move JS

$(document).ready(function(){
  $(".bubble").each(function(){
    let delay = Math.random() * 2;
    $(this).css("animation-delay", delay + "s");
  });
});

// Bubble move JS End

//circle Progressbar JS Start
document.addEventListener("DOMContentLoaded", function () {
  const progressValue = document.getElementById("progress-value");
  const circularProgress = document.querySelector(".circular-progress");
  const targetPercent = parseFloat(circularProgress.dataset.percent.replace('%', '')) || 0;
  let animated = false; // Prevent running multiple times

  function updateProgress(percentage) {
    const angle = (percentage / 100) * 360;
    circularProgress.style.background = `conic-gradient(
      #006fcf80 ${angle}deg,
      #fff ${angle}deg,
      #fff 360deg
    )`;
    progressValue.textContent = `${percentage.toFixed(1)}%`;
  }

  function animateCounter(targetPercent, duration = 1000) {
    let start = null;
    function step(timestamp) {
      if (!start) start = timestamp;
      const progress = timestamp - start;
      let percent = Math.min((progress / duration) * targetPercent, targetPercent);
      updateProgress(percent);
      if (progress < duration) {
        requestAnimationFrame(step);
      }
    }
    requestAnimationFrame(step);
  }

  // Intersection Observer for on-scroll trigger
  const observer = new IntersectionObserver((entries) => {
    entries.forEach(entry => {
      if (entry.isIntersecting && !animated) {
        animated = true;
        animateCounter(targetPercent);
      }
    });
  }, { threshold: 0.5 }); // 50% visible

  observer.observe(circularProgress);
});

//circle Progressbar JS End

// Bar Chart Js Start

document.addEventListener("DOMContentLoaded", function () {
  const section = document.querySelector(".relief-bar-chart-area");

  const observer = new IntersectionObserver((entries, observer) => {
    entries.forEach(entry => {
      if (entry.isIntersecting) {
        section.classList.add("active");
        observer.unobserve(section); // Run only once
      }
    });
  }, { threshold: 0.7 }); // Trigger when 30% visible

  if (section) {
    observer.observe(section);
  }
});

// bar Chart Js End

// Progress bar JS Start
document.addEventListener("DOMContentLoaded", function () {
  const boxes = document.querySelectorAll(".time-line-box");

  const observer = new IntersectionObserver(
    (entries) => {
      entries.forEach((entry) => {
        if (entry.isIntersecting) {
          entry.target.classList.add("in-view");
          observer.unobserve(entry.target); // only animate once
        }
      });
    },
    { threshold: 0.2 } // trigger when 20% visible
  );

  boxes.forEach((box) => observer.observe(box));
});


// Progress bar JS End



// Science Page JS End

// Review Page JS Start
$(document).ready(function(){
  $(".text-review-slider").owlCarousel({
    margin:12,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:3
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 
});

// Join the vibs Slider JS

$(document).ready(function(){
  $(".join-vibes-slider").owlCarousel({
    margin:12,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:3
	        },
	        1000:{
	            items:3
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 
});


// Review Page JS End

// Ambassador Page JS Start
jQuery(document).ready(function($) {
  // Top to Bottom slider
  $(".photo-slider-ttb").slick({
    dots: false,
    arrows: false,
    infinite: true,
    vertical: true,          
    verticalSwiping: true,   
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
  });

  // Bottom to Top slider (reverse direction)
  $(".photo-slider-btt").slick({
    dots: false,
    arrows: false,
    infinite: true,
    vertical: true,          
    verticalSwiping: true,
    autoplay: true,
    autoplaySpeed: 0,
    speed: 4000,
    pauseOnHover: false,
    pauseOnFocus: false,
    cssEase: 'linear',
    slidesToShow: 3,
    slidesToScroll: 1,
    // rtl: true                
  });
});


$(document).ready(function(){
  $(".share-earn-slider").owlCarousel({
    margin:0,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
    dotsData: false,
    // animateOut: "fadeOut", 
  // animateIn: "fadeIn"  ,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:1
	        },
	        1100:{
	            items:1
	        }
	    }
	}); 
});

// popup video stop on popup close click JS
$('.free-hoodie-area #myModal').on('hidden.bs.modal', function () {
  var video = $(this).find('video').get(0);
  if (video) {
    video.pause();
    video.currentTime = 0; // rewind to start
  }
});


jQuery(document).ready(function($) {
  $(".img-slider-ltr").slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
    speed: 5000,      
  autoplaySpeed: 0,  
  pauseOnHover: false,
  pauseOnFocus: false,
  cssEase: 'linear',
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4,
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2,
      }
    }
  ]
  });

   $(".img-slider-rtl").slick({
  dots: false,
  arrows: false,
  infinite: true,
  autoplay: true,
  rtl:true,
  speed: 5000,      
  autoplaySpeed: 0,   
  pauseOnHover: false,
  pauseOnFocus: false,
  cssEase: 'linear',
  slidesToShow: 7,
  slidesToScroll: 1,
  responsive: [
    {
      breakpoint: 1200,
      settings: {
        slidesToShow: 5
      }
    },
    {
      breakpoint: 991,
      settings: {
        slidesToShow: 4
      }
    },
    {
      breakpoint: 767,
      settings: {
        slidesToShow: 2
      }
    }
  ]
  });
});

 
$('.why-ambassador-carousel').owlCarousel({
	     margin:16,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
   dotsEach: 1,        
		pagination:false,  dots: true,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:2
	        }
	    }
	}); 


// Ambassador Page JS end

// Product Detail Page JS Start

// SIZE GUIDE MODAL POPUP JS START

document.addEventListener("DOMContentLoaded", function() {
  var modal = document.getElementById("size-guide-popup");
  if (modal) {
    // Move modal directly under <body>
    document.body.appendChild(modal);
  }
});

// SIZE GUIDE MODAL POPUP JS END


// Product Detail Page JS Start

// Collection Color Swatch JS Start

document.addEventListener("change", (event) => {
  if (event.target.matches(".mobile_card_variant input[type=radio]")) {
    const newImg = event.target.dataset.img;
    const card = event.target.closest(".card-wrapper");
    const imgEl = card.querySelector(".card__media img");

    if (newImg && imgEl) {
      imgEl.src = newImg;
      imgEl.srcset = newImg;
    }
  }
});

// Collection Color Swatch JS End

// Maquee Slider JS Start
$(document).ready(function () {
  $('.marquee-slider').slick({
    speed: 3500,              // adjust speed (lower = faster)
    autoplay: true,
    autoplaySpeed: 0,         // continuous (no stop)
    cssEase: 'linear',        // smooth linear movement
    slidesToShow: 1,          // one at a time but continuous flow
    slidesToScroll: 1,
    infinite: true,
    arrows: false,
    dots: false,
    pauseOnHover: false,
    pauseOnFocus: false,
    variableWidth: true       // prevents gap, flows like marquee
  });
});

// Maquee Slider JS Start

// MObile Best seller JS Start

document.addEventListener("DOMContentLoaded", () => {
  document.querySelectorAll(".js-menu-bestsellers .bestseller-heading").forEach((heading) => {
    heading.addEventListener("click", (e) => {
      e.stopPropagation(); // prevent drawer from closing
      heading.closest(".js-menu-bestsellers").classList.toggle("active");
    });
  });
});


// MObile Best seller JS Start
 
  document.addEventListener("DOMContentLoaded", function () {
    const variantMetafield = document.querySelector('.variant-metafield-tag-line');

    if (!variantMetafield) return;

    const observer = new MutationObserver(function (mutationsList, observer) {
      const targetContainer = document.querySelector('.rio-media-gallery');

      if (targetContainer && !targetContainer.contains(variantMetafield)) {
        targetContainer.appendChild(variantMetafield);
      }
    });

    
    observer.observe(document.body, { childList: true, subtree: true });
  }); 


 // Mobile Meet Hoodie Slider JS Start
$(document).ready(function(){
 
  $('.instant-calm-carousel').owlCarousel({
	     margin:16,
	     loop:true,
		 slideSpeed : 3000,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
    dotsEach: 1,     
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:2
	        }
	    }
	}); 
});

const elements = document.querySelectorAll('*');
elements.forEach(el => {
  const bg = window.getComputedStyle(el).backgroundColor;
  if (bg === 'rgb(128, 128, 128)') { // default grey
    el.style.backgroundColor = '#E7E6E5';
  }
});
 
(function () {
  function updateHoodieStatus() {
    let totalHoodieQty = 0;

    // --- Normal DOM search ---
    const titleSelectors = [
      '.kaching-cart-item__title'
    ];

    titleSelectors.forEach(sel => {
      document.querySelectorAll(sel).forEach(titleEl => {
        const titleText = titleEl.textContent?.trim().toLowerCase();
        if (titleText.includes('cloud hoodie')) {
          const productEl =
            titleEl.closest('[class*="kaching-cart-item__content"]') ||
            titleEl.parentElement;

          const qtyInput = productEl?.querySelector('.kaching-cart-item__quantity-input');
          if (qtyInput) totalHoodieQty += parseInt(qtyInput.value) || 0;
          
        }
      });
    });

    // --- Shadow DOM search (Upcart uses Web Components) ---
    document.querySelectorAll('*').forEach(el => {
      if (el.shadowRoot) {
        titleSelectors.forEach(sel => {
          el.shadowRoot.querySelectorAll(sel).forEach(titleEl => {
            const titleText = titleEl.textContent?.trim().toLowerCase();
            if (titleText.includes('cloud hoodie')) {
              const qtyInput = el.shadowRoot.querySelector('.kaching-cart-item__quantity-input');
              if (qtyInput) totalHoodieQty += parseInt(qtyInput.value) || 0;
            }
          });
        });
      }
    });

  // alert('🧥 Total Cloud Hoodie Qty:'+totalHoodieQty);

    // --- Toggle classes based on quantity ---
    const sec1 = document.querySelector('.before_checkout .b_sec.sec1');
    const sec2 = document.querySelector('.before_checkout .b_sec.sec2');
    const allSecs = document.querySelectorAll('.before_checkout .b_sec');
    allSecs.forEach(sec => sec.classList.remove('active'));

    if (totalHoodieQty === 1 && sec1) {
      sec1.classList.add('active');
    } else if (totalHoodieQty === 2 && sec2) {
      sec2.classList.add('active');
    }
  }

  function initHoodieWatcher() {
    const cartDrawer =
      document.querySelector('#UpcartPopup, #upcart, #UpCart, #upCart') || document.body;

    updateHoodieStatus();

    // Watch for dynamic DOM updates
    const observer = new MutationObserver(() => updateHoodieStatus());
    observer.observe(cartDrawer, { childList: true, subtree: true });

    console.log('👀 Hoodie watcher running...');
  }

  // Retry until cart drawer appears (Upcart loads async)
  function waitForCartDrawer() {
    const cartDrawer = document.querySelector('#kaching-cart, #cart-drawer ');
    if (cartDrawer) {
      initHoodieWatcher();
    } else {
      setTimeout(waitForCartDrawer, 1000);
    }
  }

  document.addEventListener('DOMContentLoaded', waitForCartDrawer);
})();

// Ambassdor Page Slider JS
$(document).ready(function(){
  $(".recent-payout-carousel").owlCarousel({
    margin:24,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
    dotsData: false,
    // animateOut: "fadeOut", 
  // animateIn: "fadeIn"  ,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:2
	        },
	        480:{
	            items:2
	        },
	        700:{
	            items:2
	        },
	        1000:{
	            items:2
	        },
	        1100:{
	            items:3
	        }
	    }
	}); 
});

$(document).ready(function(){
  $(".earn-two-step-carousel").owlCarousel({
    margin:24,
	     loop:true,
		 slideSpeed : 300,
		paginationSpeed : 400,
		autoplay:false,
		nav:true,
		pagination:false,  dots: true,
    dotsData: false,
    // animateOut: "fadeOut", 
  // animateIn: "fadeIn"  ,
		navText: [
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-left.svg?v=1754444161' alt='Previous'>",
  "<img src='https://cdn.shopify.com/s/files/1/0714/5868/5233/files/owl-arrow-right.svg?v=1754444160' alt='Next'>"
],
	    responsive:{
	        0:{
	            items:1
	        },
	        480:{
	            items:1
	        },
	        700:{
	            items:1
	        },
	        1000:{
	            items:1
	        },
	        1100:{
	            items:1
	        }
	    }
	}); 
});